import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBatmanAuth } from '../context/BatmanAuthContext';

const UserProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useBatmanAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#111111] flex items-center justify-center">
        <div className="animate-pulse text-white/50">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default UserProtectedRoute;
